import React, { useState } from 'react';
import ReactDOM from 'react-dom';
import { styled } from "styled-components";
import Card from "../card/card";
import { CloseButton } from "../button/closeButton";

const PortalWindowDiv = styled.div`
  .content {
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: ${p => p.width || '550px'};
    
    textarea {
      width: 95%;
    }
    
    @media (max-width: 768px) {
      width: 100%;
    }
  }
`;

const Wrapper = styled.div`
  opacity: 0.8;
  background: #000;
  position: fixed;
  inset: 0px;
  perspective: 1000px;
  overflow: auto;
`;

const PortalWindow = ({ children, isOpen, width, onClose }) => {
  if (!isOpen) return null;

  return ReactDOM.createPortal(
    <PortalWindowDiv className="portal-window" width={width}>
      <Wrapper className="overlay"></Wrapper>
      <div className="content">{children}</div>
    </PortalWindowDiv>,
    document.getElementById('portal-root')
  );
};

const Popup = ({open, onClose, children, height, width, showCloseBtn = true}) => {
  const [isPortalOpen, setIsPortalOpen] = useState(open || false);

  const closePortal = () => {
    setIsPortalOpen(false);
    if (onClose) {
      onClose();
    }
  };

  return isPortalOpen ? (
      <PortalWindow isOpen={isPortalOpen} onClose={closePortal} width={width}>
        <Card height={height}>
          {showCloseBtn && <CloseButton onClick={closePortal} />}
          {children}
        </Card>
      </PortalWindow>
  ) : null;
};

export default Popup;
